$(document).ready(function() {
  const $allPhoneDropdownOptions = $('.js-country-code-dropdown-option');
  const $phoneDropdownMenu = $('.js-country-code-dropdown');

  const handleClickOutside = (e) => {
      if ($(e.target).closest(".js-country-code-dropdown").length === 0) {
        const $allInactive = $('.js-country-code-dropdown-option:not(.active)')
        $allInactive.addClass('hidden');
        $phoneDropdownMenu.removeClass('open');
        $(document).unbind('click', handleClickOutside)
      }
  }

  $allPhoneDropdownOptions.click(function(e) {
    $(document).on('click', handleClickOutside);

    const $optionClicked = $(e.target).closest('.js-country-code-dropdown-option');

    if ($optionClicked.hasClass('active') && !$optionClicked.parent().hasClass('open')) {
      $phoneDropdownMenu.addClass('open');
      $allPhoneDropdownOptions.removeClass('hidden');
    } else {
      $allPhoneDropdownOptions.addClass('hidden');
      $allPhoneDropdownOptions.removeClass('active');
      $optionClicked.removeClass('hidden');
      $optionClicked.addClass('active');
      $phoneDropdownMenu.removeClass('open');
      $(document).unbind('click', handleClickOutside)
    }
  });
});
